import { Invoice, WalletAddress } from "./Billing";
import { Customer } from "./Customer";
import { Provider } from "./Provider";
import { TransactionType } from "./Transaction";

export enum NotificationEvents {
  CustomerPayBillRequest = "customer-pay-bill-request", // it will trigger when send pay request from CRM
  ScannedTransactionFound = "scanned-transaction-found", // it will trigger when scan process finds transaction
  CustomerTransactionRequest = "customer-transaction-request", // it will trigger when  send transaction request from CRM
  CustomerManualTransactionRequest = "customer-manual-transaction-request", // it will trigger when pay request is resolved

  Error = "error",
}

type BaseNotification = {
  id?: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;

  isResolved?: boolean; // seen or not
  receivingManagerId?: string;
  forAll?: boolean;

  tempId?: string;
};

export type SocketNotification =
  | {
      event: NotificationEvents.CustomerPayBillRequest;
      payload: CustomerBillingPayload;
    }
  | {
      event: NotificationEvents.CustomerTransactionRequest;
      payload: CustomerTransactionPayload;
    }
  | {
      event: NotificationEvents.ScannedTransactionFound;
      payload: ScannedTransactionPayload;
    }
  | {
      event: NotificationEvents.CustomerManualTransactionRequest;
      payload: CustomerManualTransactionPayload;
    }
  | {
      event: NotificationEvents.Error;
      payload: {
        error: string;
      };
    };

export type Notification = BaseNotification & SocketNotification;

export type CustomerBillingPayload = {
  event?: NotificationEvents;
  wallet: Partial<WalletAddress>;
  customer: Partial<Customer>;
};

export type CustomerTransactionPayload = {
  event?: NotificationEvents;
  customer: Partial<Customer>;
  provider: Partial<Provider>;
  transaction: Partial<TransactionType>;
};

export type ScannedTransactionPayload = {
  event?: NotificationEvents;
  wallet: Partial<WalletAddress>;
  customer: Partial<Customer>;
  amount: number;
};

export type CustomerManualTransactionPayload = {
  event?: NotificationEvents;
  customer: Partial<Customer>;
  invoice: Partial<Invoice>;
  transaction: Partial<TransactionType>;
};

export type NotifyMessagePayload = {
  title: string;
  body: string;
  url?: string;
};
